export default "__VITE_ASSET__C4QAs70V__"